var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductivityimg16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "url(#paint0_linear_852_1564)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    stroke: "url(#paint1_linear_852_1564)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_852_1564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.608 38.5228C22.608 38.0895 22.9635 37.9228 23.5525 37.9228C24.3969 37.9228 25.4635 38.1784 26.308 38.634V36.0228C25.3858 35.6562 24.4747 35.5117 23.5525 35.5117C21.2969 35.5117 19.7969 36.6895 19.7969 38.6562C19.7969 41.7228 24.0191 41.234 24.0191 42.5562C24.0191 43.0673 23.5747 43.234 22.9524 43.234C22.0302 43.234 20.8524 42.8562 19.9191 42.3451V44.9895C20.9524 45.434 21.9969 45.6228 22.9524 45.6228C25.2635 45.6228 26.8524 44.4784 26.8524 42.4895C26.8413 39.1784 22.608 39.7673 22.608 38.5228ZM30.1191 33.2895L27.408 33.8673L27.3969 42.7673C27.3969 44.4118 28.6302 45.6228 30.2747 45.6228C31.1858 45.6228 31.8524 45.4562 32.2191 45.2562V43.0006C31.8636 43.1451 30.108 43.6562 30.108 42.0117V38.0673H32.2191V35.7006H30.108L30.1191 33.2895ZM35.6747 36.5228L35.4969 35.7006H33.0969V45.4228H35.8747V38.834C36.5302 37.9784 37.6413 38.134 37.9858 38.2562V35.7006C37.6302 35.5673 36.3302 35.3228 35.6747 36.5228ZM38.6635 35.7006H41.4524V45.4228H38.6635V35.7006ZM38.6635 34.8562L41.4524 34.2562V32.0006L38.6635 32.5895V34.8562ZM47.2524 35.5117C46.1635 35.5117 45.4635 36.0228 45.0747 36.3784L44.9302 35.6895H42.4858V48.645L45.2635 48.0562L45.2747 44.9117C45.6747 45.2006 46.2635 45.6117 47.2413 45.6117C49.2302 45.6117 51.0413 44.0117 51.0413 40.4895C51.0302 37.2673 49.1969 35.5117 47.2524 35.5117ZM46.5858 43.1673C45.9302 43.1673 45.5413 42.934 45.2747 42.6451L45.2635 38.5228C45.5524 38.2006 45.9524 37.9784 46.5858 37.9784C47.5969 37.9784 48.2969 39.1117 48.2969 40.5673C48.2969 42.0562 47.608 43.1673 46.5858 43.1673ZM59.7969 40.6006C59.7969 37.7562 58.4191 35.5117 55.7858 35.5117C53.1413 35.5117 51.5413 37.7562 51.5413 40.5784C51.5413 43.9228 53.4302 45.6117 56.1413 45.6117C57.4635 45.6117 58.4635 45.3117 59.2191 44.8895V42.6673C58.4636 43.0451 57.5969 43.2784 56.4969 43.2784C55.4191 43.2784 54.4635 42.9006 54.3413 41.5895H59.7747C59.7747 41.445 59.7969 40.8673 59.7969 40.6006ZM54.308 39.5451C54.308 38.2895 55.0747 37.7673 55.7747 37.7673C56.4524 37.7673 57.1747 38.2895 57.1747 39.5451H54.308Z",
    fill: "#A6A6C9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_852_1564",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05050F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8DB9",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_852_1564",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27273F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_852_1564"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductivityimg16);
export default __webpack_public_path__ + "static/media/productivityimg16.a5be6dcdd9eb25207871b8674be3a27c.svg";
export { ForwardRef as ReactComponent };